<template>
  <div class="hxhz">
    <router-link to="/overview"  target="_blank">
      <div class="hxhz-c">
        <p><countTo :startVal='0' :endVal='totalcapacity' :duration='15000'></countTo><a style="font-size: 14px">+万吨</a></p>
        <em></em>
        <font>化纤产业当年产能</font>
      </div>
    </router-link>
    <div class="hxhz-tl">
      <span class="hxhz-tit">{{ year }}年</span>
      <div class="hxhz-content">
        <p><countTo :startVal='0' :endVal='40000' :duration='8000'></countTo><span style="font-size: 12px">台</span></p>
        <a>设备接入</a>
        <em></em>
<!--        <font>目标<i>7</i>万台</font>-->
      </div>
    </div>
    <div class="hxhz-tr">
      <span class="hxhz-tit">{{ year }}年</span>
      <div class="hxhz-content">
        <p><countTo :startVal='0' :endVal='4125' :duration='8000'></countTo><span style="font-size: 12px">家</span></p>
        <a>服务企业</a>
        <em></em>
<!--        <font>目标接入<i>6</i>千家</font>-->
      </div>
    </div>
    <div class="hxhz-bl">
      <span class="hxhz-tit">接入企业</span>
      <div class="hxhz-content">
        <p><countTo :startVal='0' :endVal='41' :duration='8000'></countTo><span style="font-size: 12px">家</span></p>
        <a>化纤大型企业</a>
        <em></em>
<!--        <font>交易<i>330</i>万吨</font>-->
      </div>
    </div>
    <div class="hxhz-br">
      <span class="hxhz-tit">节能减碳</span>
      <div class="hxhz-content">
        <p><countTo :startVal='0' :endVal='250' :duration='8000'></countTo><span style="font-size: 12px">+万吨</span></p>
        <a>3年内减排</a>
        <em></em>
<!--        <font><i>225</i>万塑托</font>-->
      </div>
    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to';
export default {
  name: "left-module-one",
  components:{
    countTo
  },
  props: {
    clienttotal:{
      type:Number,
      default:''
    },
    totalcapacity:{
      type:Number,
      default:''
    }
  },
  data(){
    return {
      year:new Date().getFullYear(),
    }
  },
  mounted() {

  },
  methods:{

  }
}
</script>

<style scoped>
.hxhz{
  width: 10px;
  height: 10px;
  margin: 124px auto;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -5px;
  margin-top: 5px;
}

.hxhz-c{
  width: 179px;
  height: 128px;
  background: url("../../../assets/bj-2.png") no-repeat center/100%;
  position: absolute;
  top: -62px;
  left: -84px;
  text-align: center;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-content: center;
  color: #fff;
}

.hxhz-c p{
  width: 100%;
  font-size: 29px;
  font-weight: bold;
  font-family: Arial;
  color: #2487FF;
  background: -webkit-linear-gradient(90deg, #00D2E9,#fff,#fff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.hxhz-c em{
  width: 25px;
  height: 2px;
  background: #04D60B;
  margin: 3px 0 8px 0;
}

.hxhz-c font{
  width: 100%;
  font-weight: bold;
  font-size: 12px;
  background: -webkit-linear-gradient(90deg, #313140,#fff,#fff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.hxhz-tl,.hxhz-tr{
  width: 117px;
  height: 105px;
  background: url("../../../assets/bj-3.png") no-repeat center/100%;
  position: absolute;
  top: -110px;
  left: -152px;
}

.hxhz-tr{
  left: 46px;
}

.hxhz-bl,.hxhz-br{
  width: 117px;
  height: 105px;
  background: url("../../../assets/bj-4.png") no-repeat center/100%;
  position: absolute;
  top: 10px;
  left: -152px;
}

.hxhz-br{
  left: 46px;
}

.hxhz-tit{
  width: 100%;
  font-size: 12px;
  color: #B8B8C7;
  position: absolute;
  top: -11px;
  text-align: center;
}

.hxhz-bl .hxhz-tit,.hxhz-br .hxhz-tit{
  top: 98px;
}

.hxhz-content{
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-content: center;
  color: #fff;
}

.hxhz-content p{
  width: 100%;
  font-size: 18px;
  font-weight: bold;
  font-family: Arial;
  color: #2487FF;
  background: -webkit-linear-gradient(90deg, #00D2E9,#fff,#fff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.hxhz-content em{
  width: 25px;
  height: 2px;
  background: #04D60B;
  margin: 3px 0 4px 0;
}

.hxhz-content a{
  width: 100%;
  font-weight: bold;
  font-size: 9px;
  background: -webkit-linear-gradient(90deg, #3ED7DB,#fff,#fff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.hxhz-content font{
  width: 100%;
  font-size: 12px;
  font-weight: bold;
  background: -webkit-linear-gradient(90deg, #50E684,#fff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.hxhz-content i{
  font-size: 16px;
}

</style>



// WEBPACK FOOTER //
// src/views/HomeManage/module/left-module-one.vue